import React, { Component } from "react";
import { useState } from "react";
import { useRef } from "react";


const DropHandles = ({
    dropHandles,
    rowId,
    sectionId,
    pageId,
    onDrop,
    onDragLeave,
    onDragOver,
    rowIndex,
    hideHandlersFunc
}) => {
    const innerLine = useRef(null)
    const [displayLine, setDisplayLine] = useState(true)
    const onHandleDrop = (e, rowId, sectionId, pageId, direction) => {
        e.target.style.background = "none";

        onDrop(e, rowId, sectionId, pageId, direction);
    };

    return (

        <div>

            {dropHandles.map((handler, index) => {
                const { direction, style } = handler;
                if (rowIndex > 0) {
                    return (
                        <div onDrop={(e) => onHandleDrop(e, rowId, sectionId, pageId, direction)} onDragOver={(e) => onDragOver(e, innerLine.current)} onDragLeave={(e) => onDragLeave(e, innerLine.current)} key={index} className={"handler " + "bottom"}>
                            <div ref={innerLine} style={{ width: '95%', height: 1, borderTop: '1px dashed #6D79CC', pointerEvents: 'none' }}></div>
                        </div>
                    );
                }
                return (
                    <div onDrop={(e) => onHandleDrop(e, rowId, sectionId, pageId, direction)} onDragOver={(e) => onDragOver(e, innerLine.current)} onDragLeave={(e) => onDragLeave(e, innerLine.current)} key={index} className={"handler " + direction}>
                        <div ref={innerLine} style={{ width: '95%', height: 1, borderTop: '1px dashed #6D79CC', pointerEvents: 'none' }}></div>
                    </div>
                );
            })}
        </div>
    );
};

export default DropHandles;
